import type { ThisMonthInProgressDTO } from "../models/thisMonthInProgressDto";
import type { ThisMonthInProgressEntity } from "../../domain/entities/ThisMonthInProgressEntity";

export function thisMonthInProgressDtoToEntity(
  dto: ThisMonthInProgressDTO
): ThisMonthInProgressEntity {
  return {
    monthTitle: dto.monthTitle ?? "",
    asOfLabel: dto.asOfLabel ?? "",
    balancesAsOfLabel: dto.balancesAsOfLabel ?? "",
    revenueMtd: Number(dto.revenueMtd) || 0,
    revenueMtdChangePercent: dto.revenueMtdChangePercent ?? null,
    expenseMtd: Number(dto.expenseMtd) || 0,
    expenseMtdChangePercent: dto.expenseMtdChangePercent ?? null,
    receivablesMtd: Number(dto.receivablesMtd) || 0,
    payablesMtd: Number(dto.payablesMtd) || 0,
    cashBalanceMtd: Number(dto.cashBalanceMtd) || 0,
  };
}
